import React from 'react';
import { Route, Redirect } from 'react-router';
import Layout from './components/Layout';
import Home from './components/Home';
import TwoFactorLoginPage from './components/TwoFactorLoginPage'
import { tokenService } from './services/tokenService';
import jwtDecode from 'jwt-decode'
import {configuration} from "./configuration";


export default () => (
    <Layout>
        <Route exact path='/' component={Home} />
        <Route path='/(t|kyc)/:id' render={props => {
            const urlParams = new URLSearchParams(window.location.search);
            const accessToken = urlParams.get('accessToken');
            if (props.location.pathname.toString().includes("kyc")) {
                window.history.pushState("", "Onboarding", "/kyc/" + props.match.params.id);
            } else {
                window.history.pushState("", "Onboarding", "/t/" + props.match.params.id);
            }
            if (configuration.ENVIRONMENT === 'development') {
                return <Home {...props} />;
            }
            if (sessionStorage.getItem('user')) {
                let jwtToken = sessionStorage.getItem('user');
                let decodedToken = jwtDecode(jwtToken);
                let current_time = new Date().getTime()/1000;
                if (current_time > decodedToken.exp) {
                    if (accessToken) {
                        let decodedCookieToken = jwtDecode(accessToken);
                        tokenService.login(accessToken);
                        if (current_time > decodedCookieToken.exp) {
                            return <Redirect to={{ pathname: '/login', state: { from: props.location } }} />;
                        } else {
                            return <Home {...props} />;
                        }
                    } else {
                        return <Redirect to={{ pathname: '/login', state: { from: props.location } }} />;
                    }
                } else {
                    return <Home {...props} />;
                }
            } else if (accessToken) {
                let decodedCookieToken = jwtDecode(accessToken);
                tokenService.login(accessToken)
                let current_time = new Date().getTime()/1000;
                if (current_time > decodedCookieToken.exp) {
                    return <Redirect to={{ pathname: '/login', state: { from: props.location } }} />;
                } else {
                    return <Home {...props} />;
                }
            } else {
                return <Redirect to={{ pathname: '/login', state: { from: props.location } }} />;
            }
        }} />
        <Route exact path='/login' component={TwoFactorLoginPage} />
    </Layout>
);

